module.exports = __webpack_public_path__ + "img/ca90a179d40b4ff50c2cd1ce733f4bad.svg";